class UserRightModel {
  id = null;
  name = null;
  display_name = null;
  constructor(userRightData) {
    if (userRightData !== undefined) {
      let { id, name, display_name } = userRightData;
      Object.assign(this, {
        id,
        name,
        display_name
      });
    }
  }
}

export default UserRightModel;
